import Layout from "@/components/Layout";
import { Construction, UserPlus } from "lucide-react";

export default function AdmissionPlaceholder() {
  return (
    <Layout>
      <PlaceholderPanel icon={UserPlus} title="Admissions" subtitle="Coming soon" tone="violet" testid="admission-placeholder">
        Capture new admission enquiries, generate application numbers, schedule entrance assessments,
        and move accepted students straight into the roster — all without leaving the dashboard.
      </PlaceholderPanel>
    </Layout>
  );
}

function PlaceholderPanel({ icon: Icon, title, subtitle, tone, children, testid }) {
  const colors = {
    violet: "from-violet-50 to-white border-violet-200 text-violet-700 dark:from-violet-950/40 dark:border-violet-800 dark:text-violet-200",
    emerald: "from-emerald-50 to-white border-emerald-200 text-emerald-700 dark:from-emerald-950/40 dark:border-emerald-800 dark:text-emerald-200",
  }[tone] || "";
  return (
    <div className={`max-w-3xl mx-auto rounded-3xl border bg-gradient-to-br p-10 sm:p-14 text-center ${colors}`} data-testid={testid}>
      <div className="mx-auto mb-6 h-16 w-16 rounded-2xl bg-white dark:bg-slate-800 border border-current/10 flex items-center justify-center shadow-sm">
        <Icon className="h-8 w-8" />
      </div>
      <div className="text-xs uppercase tracking-[0.25em] opacity-70 mb-2">{subtitle}</div>
      <h1 className="text-4xl font-bold text-slate-900 dark:text-slate-100 mb-3" style={{fontFamily:"Outfit"}}>{title}</h1>
      <p className="text-slate-600 dark:text-slate-300 max-w-xl mx-auto mb-6">{children}</p>
      <div className="inline-flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 bg-white/70 dark:bg-slate-900/40 backdrop-blur px-3 py-1.5 rounded-full">
        <Construction className="h-3.5 w-3.5" /> Module placeholder · not yet wired up
      </div>
    </div>
  );
}

export { PlaceholderPanel };
